/**
 * 去字幕输入区 — 视频选择 + 提交按钮
 */
import React, { useRef } from 'react';
import { Upload, FolderOpen, X, Send, Loader2, AlertTriangle } from 'lucide-react';

const PostProcessInput = ({
  sourceVideo,
  onSourceVideoChange,
  onSubmit,
  isSubmitting,
  onOpenResourceSelector,
  onLocalUpload,
  theme,
}) => {
  const fileInputRef = useRef(null);
  const color = 'var(--color-error)';
  const colorDashed = 'color-mix(in srgb, var(--color-error) 31%, transparent)';

  return (
    <div className="rounded-2xl" style={{ backgroundColor: 'var(--color-bg-secondary)', border: '1px solid var(--color-border-primary)' }}>
      {/* 视频选择区 */}
      <div className="p-4">
        <div className="text-xs font-bold mb-3" style={{ color: 'var(--color-text-primary)' }}>
          📹 选择要去字幕的视频
        </div>

        {sourceVideo ? (
          <div className="flex items-center gap-3 p-3 rounded-xl" style={{ backgroundColor: 'var(--color-bg-tertiary)', border: '1px solid var(--color-border-primary)' }}>
            <div className="w-16 h-16 rounded-lg flex items-center justify-center shrink-0" style={{ backgroundColor: 'var(--color-bg-overlay)' }}>
              <video src={sourceVideo.url} className="w-full h-full object-cover rounded-lg" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-xs font-medium truncate" style={{ color: 'var(--color-text-primary)' }}>{sourceVideo.name || '视频'}</div>
              <div className="text-2xs mt-0.5 truncate" style={{ color: 'var(--color-text-muted)' }}>{sourceVideo.url}</div>
            </div>
            <button onClick={() => onSourceVideoChange(null)} className="p-1.5 rounded-lg hover:bg-[var(--color-red-light)] transition-all" style={{ color: theme.colors.error }}>
              <X size={14} />
            </button>
          </div>
        ) : (
          <div className="flex gap-2">
            <button onClick={onOpenResourceSelector}
              className="va-btn flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-xs font-medium transition-all"
              style={{ border: `1px dashed ${colorDashed}`, color }}
            >
              <FolderOpen size={16} /> 从资源库选择
            </button>
            <button onClick={() => fileInputRef.current?.click()}
              className="va-btn flex-1 flex items-center justify-center gap-2 px-4 py-3 rounded-xl text-xs font-medium transition-all"
              style={{ border: `1px dashed ${colorDashed}`, color }}
            >
              <Upload size={16} /> 本地上传
            </button>
            <input ref={fileInputRef} type="file" accept="video/mp4,video/quicktime,video/webm" className="hidden"
              onChange={(e) => { if (e.target.files?.[0]) onLocalUpload(e.target.files[0]); e.target.value = ''; }}
            />
          </div>
        )}
      </div>

      {/* 去字幕要求 */}
      <div className="px-4 pb-3">
        <div className="flex items-start gap-2 p-3 rounded-xl" style={{ backgroundColor: 'color-mix(in srgb, var(--color-error) 10%, transparent)', border: '1px solid color-mix(in srgb, var(--color-error) 20%, transparent)' }}>
          <AlertTriangle size={14} style={{ color: 'var(--color-error)', marginTop: 2 }} />
          <div className="text-2xs leading-relaxed" style={{ color: 'var(--color-error)' }}>
            <strong>注意：</strong>仅支持视频服务生成的原始视频 URL（24小时有效期）。重新上传或转存后的 URL 无法使用。
          </div>
        </div>
      </div>

      {/* 提交按钮 */}
      <div className="flex items-center justify-end px-4 pb-3">
        <button
          onClick={onSubmit}
          disabled={isSubmitting || !sourceVideo}
          className="va-btn flex items-center gap-2 px-5 py-2 rounded-full text-xs font-bold disabled:opacity-40"
          style={{ backgroundColor: color, color: 'white' }}
        >
          {isSubmitting ? (
            <>
              <Loader2 size={14} className="animate-spin" /> 处理中...
            </>
          ) : (
            <>
              <Send size={14} /> 开始去字幕
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default PostProcessInput;
